import React from 'react'
import Sidebar from '.'
import adminSidebarItems from './adminSidebar.const'

function AdminSidebar() {
    return <Sidebar sidebarItems={adminSidebarItems} />
}

export default AdminSidebar
